import FullScreenDialog, { FullScreenDialogCloseReason } from "../../../components/full-screen-dialog/FullScreenDialog";
import { BindDialogReturn, DialogProps, DialogResult, DialogState } from "../../../hooks/use-dialog-state/UseDialogState";
import UICustomizationPresetEditor from "./UICustomizationPresetEditor";

import type { JSX } from "react";

export type UICustomizationPresetEditorDialogInitValues = {
    presetID: number;
    organizationID: number | undefined;
};

export type UICustomizationPresetEditorDialogResultValues = {
    presetID: number | undefined;
};

export type UICustomizationPresetEditorDialogResultReason = FullScreenDialogCloseReason | "cancel" | "saveAsNew" | "saveChanges";

export type UICustomizationPresetEditorDialogResult = DialogResult<UICustomizationPresetEditorDialogResultValues, UICustomizationPresetEditorDialogResultReason>;

export type UICustomizationPresetEditorDialogProps = DialogProps<UICustomizationPresetEditorDialogInitValues, UICustomizationPresetEditorDialogResult>;

export default function UICustomizationPresetEditorDialog({
    open,
    onClose,
    values
}: UICustomizationPresetEditorDialogProps): JSX.Element {

    return (
        <FullScreenDialog open={open} onClose={reason => onClose({ reason: reason })}>
            <UICustomizationPresetEditor
                presetID={values?.presetID}
                organizationID={values?.organizationID}
                onClose={({reason, presetID}) => onClose({
                    reason: reason,
                    values: {
                        presetID: presetID
                    }
                })}
            />
        </FullScreenDialog>
    );
}

export type UICustomizationPresetEditorDialogState = DialogState<UICustomizationPresetEditorDialogInitValues, UICustomizationPresetEditorDialogResult>;
export type BindUICustomizationPresetEditorDialogReturn = BindDialogReturn<UICustomizationPresetEditorDialogInitValues, UICustomizationPresetEditorDialogResult>;